import React from 'react';
import Dashboard from 'components/Dashboard';
import DefaultLayout from 'components/DefaultLayout';
import SparkHistory from 'components/History';
import Memories from 'components/Memories';
import SparksPage from 'components/Sparks/SparkPage';
import Connections from 'components/Settings/Connections';
import { Routes, Route, Navigate } from 'react-router-dom';
import { SPARK_ROUTES } from 'constants/routes';
import SparkBoards from 'components/SparkBoards';

function MainAppRouts() {
  return (
    <DefaultLayout>
      <Routes>
        <Route path={SPARK_ROUTES.DASHBOARD} element={<Dashboard />} />
        <Route path='/sparks' element={<SparksPage />} />
        <Route path={SPARK_ROUTES.MEMORIES} element={<Memories />} />
        <Route path={SPARK_ROUTES.HISTORY} element={<SparkHistory />} />
        <Route path={SPARK_ROUTES.BOARD} element={<SparkBoards />} />
        <Route path='/*' element={<Navigate to='/dashboard' />} />
      </Routes>
    </DefaultLayout>
  );
}

export default MainAppRouts;
